import { render, staticRenderFns } from "./VTableRow.vue?vue&type=template&id=7a316e50&"
import script from "./VTableRow.vue?vue&type=script&lang=ts&"
export * from "./VTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./VTableRow.vue?vue&type=style&index=0&id=7a316e50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports